<template>
  <div class="custom-editor-box">
    <!-- <el-form
      ref="articleForm"
      label-width="0px"
      :model="articleForm"
      :rules="rules"
      class="custom-form-box"
    >
      <el-form-item>
        <quill-editor
          ref="myQuillEditor"
          v-model="articleForm.artContent"
          v-screen
          class="quilleditor"
          :options="editorOption"
          style="height: 265px"
        />
      </el-form-item>
    </el-form> -->
    <div>
      <quill-editor ref="myQuillEditor" v-model="articleForm.artContent" class="quilleditor" :options="editorOption"
        style="height: 300px" @change="onEditorChange($event)" />
    </div>
  </div>
</template>
<script>
import { quillEditor } from "vue-quill-editor";
import * as Quill from "quill";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import "../css/quillEditor.css"; //自定义css
import { addQuillTitle } from "../js/quill-title.js"; //设置工具栏鼠标悬浮中文提示
// 字体
var fonts = [
  "SimHei",
  "SimSun",
  "Microsoft-YaHei",
  "KaiTi",
  "FangSong",
  "Arial",
  "sans-serif",
];
var Font = Quill.import("formats/font");
Font.whitelist = fonts;
Quill.register(Font, true);
// 字体大小
var sizes = [false, "14px", "16px", "18px", "20px", "22px", "24px", "26px"];
var Size = Quill.import("formats/size");
Size.whitelist = sizes;
// 行高
import { lineHeightStyle } from "../js/lineHeight.js";
Quill.register({ "formats/lineHeight": lineHeightStyle }, true);
// 行间距
import { letterSpacingStyle } from "../js/letterSpacing.js";
Quill.register({ "formats/letterSpacing": letterSpacingStyle }, true);
// 链接
var Link = Quill.import("formats/link");
class MyLink extends Link {
  static create(value) {
    let node = super.create(value);
    value = this.sanitize(value);
    if (!value.startsWith("http")) {
      value = "http://" + value;
    }
    node.setAttribute("href", value);
    return node;
  }
}
Quill.register(MyLink);

// 工具栏配置
const toolbarOptions = [
  ["bold", "italic", "underline"], // 加粗 斜体 下划线 删除线 -----['bold', 'italic', 'underline', 'strike']
  // [{ header: '1' }, { header: '2' }], // 1、2 级标题-----[{ header: 1 }, { header: 2 }]
  // ["blockquote", "code-block"], // 引用  代码块-----['blockquote', 'code-block']
  [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表-----[{ list: 'ordered' }, { list: 'bullet' }]
  [{ script: "sub" }, { script: "super" }], // 上标/下标-----[{ script: 'sub' }, { script: 'super' }]
  [{ align: [] }], // 对齐方式-----[{ align: [] }]
  [{ indent: "-1" }, { indent: "+1" }], // 缩进-----[{ indent: '-1' }, { indent: '+1' }]
  [{ direction: "rtl" }], // 文本方向-----[{'direction': 'rtl'}]
  [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色-----[{ color: [] }, { background: [] }]
  [{ size: sizes }], // 字体大小-----[{ size: ['small', false, 'large', 'huge'] }]
  [{ header: [false, 1, 2, 3, 4, 5, 6] }], // 标题-----[{ header: [1, 2, 3, 4, 5, 6, false] }]
  [{ font: fonts }], // 字体种类-----[{ font: [] }]
  [{ lineheight: ["initial", "1", "1.5", "1.75", "2", "3", "4", "5"] }], //行高
  [
    {
      letterSpacing: [
        "initial",
        "2px",
        "4px",
        "6px",
        "8px",
        "10px",
        "12px",
        "14px",
        "16px",
      ],
    },
  ], //行间距
  // ["link", "image", "video"], // 链接、图片、视频-----['link', 'image', 'video']
  ["clean"], // 清除文本格式-----['clean']
];
export default {
  components: {
    quillEditor,
  },
  // directives: { screen }, //最大化最小化
  data() {
    return {
      articleForm: {
        artContent: "",
      },
      rules: {},
      headers: {},
      // action: uploadURL,
      action: "",
      fileListQuill: [],
      editorOption: {
        modules: {
          toolbar: {
            container: toolbarOptions, //自定义工具栏
            handlers: {
              letterSpacing: function (value) {
                if (value) {
                  this.quill.format("letterSpacing", value);
                } else {
                  console.log(value);
                }
              },
              lineheight: function (value) {
                if (value) {
                  this.quill.format("lineHeight", value);
                } else {
                  console.log(value);
                }
              },
              image: function (value) {
                if (value) {
                  document.querySelector(".pictureQuill input").click();
                } else {
                  this.quill.format("image", false);
                }
              },
              video: function (value) {
                if (value) {
                  document.querySelector(".pictureQuillVideo input").click();
                } else {
                  this.quill.format("video", false);
                }
              },
            },
          },
        },
        //主题
        theme: "snow",
        placeholder: "请输入正文",
      },
      //视频
      videoFlag: false,
      //是否显示进度条
      videoUploadPercent: "",
      //进度条的进度，
      isShowUploadVideo: false,
      //显示上传按钮
      videoForm: {
        showVideoPath: "",
      },
    };
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill;
    },
  },
  created() {
    this.headers["Authorization"] = `Bearer ${this.token}`;
  },
  mounted() {
    // 富文本工具栏提示
    addQuillTitle();
    //解决文本框赋值后获取焦点
    this.$refs.myQuillEditor.quill.enable(false);
    this.$nextTick(function () {
      this.$refs.myQuillEditor.quill.enable(true);
      this.$refs.myQuillEditor.quill.blur();
    });
  },
  methods: {
    clearContent() {
      this.articleForm.artContent = ''
    },
    inputContent(data) {
      this.articleForm.artContent = data
    },
    onEditorChange() {
      this.$emit('editorTransfer', this.articleForm.artContent)
    }, // 内容改变触发事件
    // 富文本框上传图片回调
    bfUpload(file) {
      if (
        "image/png" == file.type ||
        "image/jpeg" == file.type ||
        "image/jpg" == file.type
      ) {
        console.log();
      } else {
        this.ME("图片上传失败,请上传png,jpeg,jpg格式");
        return false;
      }
    },
    // 富文本框上传图片
    handleSuccessQuill(response, file) {
      this.fileListQuill.push({ url: response.data.filePath });
      let quill = this.$refs.myQuillEditor.quill;
      if (response.data.filePath) {
        let length = quill.getSelection().index;
        quill.insertEmbed(length, "image", response.data.filePath);
        quill.setSelection(length + 1);
      }
    },
    //富文本上传视频回调
    beforeUploadVideo(file) {
      var fileSize = file.size / 1024 / 1024 < 50;
      if (
        [
          "video/mp4",
          "video/ogg",
          "video/flv",
          "video/avi",
          "video/wmv",
          "video/rmvb",
          "video/mov",
        ].indexOf(file.type) == -1
      ) {
        this.$message.error("请上传正确的视频格式");
        return false;
      }
      if (!fileSize) {
        this.$message.error("视频大小不能超过50MB");
        return false;
      }
      this.isShowUploadVideo = false;
    },
    //进度条
    uploadVideoProcess(event, file, fileList) {
      this.videoFlag = true;
      this.videoUploadPercent = file.percentage.toFixed(0) * 1;
    },
    //富文本上传视频
    handleVideoSuccess(res, file) {
      this.isShowUploadVideo = true;
      this.videoFlag = false;
      this.videoUploadPercent = 0;
      let quill = this.$refs.myQuillEditor.quill;
      this.videoForm.showVideoPath = res.data.filePath;
      if (res.data.filePath) {
        let length = quill.getSelection().index;
        quill.insertEmbed(length, "video", res.data.filePath);
        quill.setSelection(length + 1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-editor-box {
  width: 100%;
  height: 100%;

  ::v-deep .ql-container {
    height: calc(100% - 90px);
  }
}
</style>
